// extracted by mini-css-extract-plugin
export default {"main":"Input_main__aiONY","input":"Input_input__WFZkr","icon":"Input_icon__8eLgl","inputContainer":"Input_inputContainer__vNHnJ"};